import UploadFile from "./UploadFile";

(function () {
  const styles = ".upload-wrapper .spinner {\n  margin: 7px 0 0 15px;\n}\n.upload-wrapper .spinner__rectangle {\n  width: 3px;\n}";
  const fileName = "index_UploadFile";
  const element = document.querySelector("style[data-sass-component='index_UploadFile']");

  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

export default UploadFile;